export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14089.ce32694f.jpg";